import React from "react";
import type { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import Dropdown from "react-bootstrap/Dropdown";
import camelCase from "lodash/camelCase";
import Tooltip from "@edaz/edazkit/Tooltip";
import type DocumentsInventoryViewModel from "viewModels/finance/accountingInventory/documentsInventory/documentsInventoryViewModel";
import type AccountingDocumentsInventoryResponse from "entities/accountingDocumentsInventoryResponse";

export interface DocumentsInventoryMenuProps {
  vm: DocumentsInventoryViewModel;
  inventory: AccountingDocumentsInventoryResponse;
}

const DocumentsInventoryMenu: FunctionComponent<DocumentsInventoryMenuProps> = observer((props: DocumentsInventoryMenuProps) => {
  const { vm, inventory } = props;

  return (
    <Dropdown drop="left">
      <Dropdown.Toggle size="sm" variant="success" className="rounded caret-off">
        ⋮
      </Dropdown.Toggle>
      <Dropdown.Menu alignRight={true}>
        {vm.actions(inventory).map(action => {
          const permittedActions = vm[`allowTo${action}`](inventory);
          let content: React.ReactNode = vm.translate(`actions.${camelCase(action)}.name`);
          if (!permittedActions.isAllowed) {
            content = (
              <Tooltip id={`charge-${inventory.id}-${action}`} tooltip={vm.disabledActionTooltip(action, inventory)}>
                <span>{content}</span>
              </Tooltip>
            );
          }

          return (
            <Dropdown.Item
              key={action}
              disabled={!permittedActions.isAllowed}
              onClick={() => vm[`on${action}Click`](inventory)}
              style={{ pointerEvents: "auto" }}>
              {content}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
});

export default DocumentsInventoryMenu;
